import ErrorResponse from "@/types/ErrorResponse";
import { AxiosError, isAxiosError } from "axios";
import { defineStore } from "pinia";
import { ref, Ref } from "vue";

export const useSnackbar = defineStore("snackbar", () => {
  const visible: Ref<boolean> = ref(false);
  const message: Ref<string> = ref("");
  const timeout: Ref<number> = ref(5000);
  const color: Ref<string> = ref("");

  function show(_message: string, _color: string, _timeout?: number): void {
    message.value = typeof _message === "string" ? _message.toUpperCase() : "";
    timeout.value = _timeout ?? 5000;
    color.value = _color;
    visible.value = true;
  }

  function error(e: unknown, defaultMessage = "Erro desconhecido"): void {
    let message = defaultMessage;

    if (isAxiosError(e)) {
      const error = e as AxiosError<ErrorResponse>;

      message = error.response?.data.message ?? defaultMessage;
    } else {
      console.log(e);
    }

    show(message, "error");
  }

  function hide(): void {
    visible.value = false;
    color.value = "";
    message.value = "";
  }

  return {
    visible,
    message,
    timeout,
    color,
    show,
    hide,
    error,
  };
});
